import React from "react";
import { BoxIcon } from "lucide-react";
type BookCoverProps = {
  kicker: string;
  title: string;
  color: string;
  icon: BoxIcon;
  variant?: "volume" | "bonus";
  className?: string;
};

// Temporary coded cover — replace with real cover art when available.
export function BookCover({
  kicker,
  title,
  color,
  icon: Icon,
  variant = "volume",
  className = ""
}: BookCoverProps) {
  const isBonus = variant === "bonus";
  return <div aria-hidden="true" className={`relative aspect-[3/4] overflow-hidden rounded-[3%_6%_6%_3%/2%_4%_4%_2%] shadow-[0_18px_32px_-14px_rgba(11,24,56,0.55)] ${className}`} style={{
    containerType: "inline-size",
    backgroundColor: isBonus ? "#FFF8EA" : color
  }} data-id="element-21" data-mp="2o77x0iqvyxnq">
      {isBonus && <span className="absolute inset-x-0 top-0 h-[31%]" style={{
      backgroundColor: color
    }} data-id="element-22" data-mp="29i3e0zc9opek" />}
      <span className="absolute inset-y-0 left-0 w-[7%] bg-black/15" data-id="element-23" data-mp="24ge5bqciontn" />
      <span className="absolute inset-y-0 left-[7%] w-[1.5%] bg-white/20" data-id="element-24" data-mp="20fu52dwnd43a" />

      <div className="relative flex h-full flex-col" style={{
      padding: "9cqw 8cqw 8cqw 15cqw"
    }} data-id="element-25" data-mp="19arbv2foddqh">
        <p className="font-display font-extrabold uppercase leading-none text-[#FFD873]" style={{
        fontSize: "5.6cqw",
        letterSpacing: "0.1em"
      }} data-id="element-26" data-mp="1e17v5366ftkr">
          Why We Believe
        </p>
        <p className="font-display font-bold uppercase leading-none text-white/80" style={{
        fontSize: "4.4cqw",
        letterSpacing: "0.14em",
        marginTop: "3cqw"
      }} data-id="element-27" data-mp="14b52x56vqjnh">
          {kicker}
        </p>
        <p className={`font-display font-extrabold ${isBonus ? "text-navy" : "text-white"}`} style={{
        fontSize: isBonus ? "9cqw" : "9.6cqw",
        lineHeight: 1.08,
        marginTop: isBonus ? "22cqw" : "8cqw"
      }} data-id="element-28" data-mp="1wzao1t1uianu">
          {title}
        </p>
        <div className="mt-auto flex items-end justify-between" style={{
        gap: "3cqw"
      }} data-id="element-29" data-mp="7lfa85i28bwv">
          <span className="flex items-center justify-center rounded-full" style={{
          width: "21cqw",
          height: "21cqw",
          backgroundColor: isBonus ? color : "rgba(255,255,255,0.16)"
        }} data-id="element-30" data-mp="bmr2yjw8dd9a">
            <Icon className="text-white" style={{
            width: "11cqw",
            height: "11cqw"
          }} strokeWidth={2} data-id="element-31" data-mp="29abcazk5aqn7" />
          </span>
          <span className={`text-right font-semibold leading-tight ${isBonus ? "text-ink-soft" : "text-white/75"}`} style={{
          fontSize: "3.8cqw",
          maxWidth: "40cqw"
        }} data-id="element-32" data-mp="24hrz43pddxix">
            The Kids' Faith Mega Bundle
          </span>
        </div>
      </div>
    </div>;
}